var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoiaPositivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26351 6.44775H4.88169V12.6878H2.26351C2.14778 12.6878 2.03679 12.6372 1.95496 12.5472C1.87312 12.4571 1.82715 12.3351 1.82715 12.2078V6.92775C1.82715 6.80045 1.87312 6.67836 1.95496 6.58834C2.03679 6.49833 2.14778 6.44775 2.26351 6.44775V6.44775Z",
    stroke: "currentColor",
    strokeWidth: 0.873298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88135 6.44771L7.06317 1.64771C7.52609 1.64771 7.97005 1.84999 8.29739 2.21006C8.62472 2.57013 8.80862 3.05849 8.80862 3.56771V5.00771H12.185C12.3087 5.00737 12.4311 5.03617 12.5439 5.09216C12.6567 5.14816 12.7573 5.23006 12.8389 5.33236C12.9206 5.43466 12.9813 5.555 13.0172 5.68528C13.0531 5.81556 13.0631 5.95278 13.0468 6.08771L12.3923 11.8477C12.3658 12.0789 12.2637 12.2917 12.1052 12.4462C11.9466 12.6008 11.7423 12.6866 11.5304 12.6877H4.88135",
    stroke: "currentColor",
    strokeWidth: 0.873298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoiaPositivo);
export default __webpack_public_path__ + "static/media/JoiaPositivo.8416dcf39dba726eb19bcd1a3b634d01.svg";
export { ForwardRef as ReactComponent };